import { render, staticRenderFns } from "./MessageSubscription.vue?vue&type=template&id=1c90ab7c&scoped=true&"
import script from "./MessageSubscription.vue?vue&type=script&lang=js&"
export * from "./MessageSubscription.vue?vue&type=script&lang=js&"
import style0 from "./MessageSubscription.vue?vue&type=style&index=0&id=1c90ab7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c90ab7c",
  null
  
)

export default component.exports